import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import {
  AreaField,
  Button,
  Card,
  FetchStatusFlow,
  FlexRow,
  Grid,
  Header2Text,
  IconType,
  ISelectOption,
  RotatingIcon,
  SelectField,
} from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { commentSchema } from './commentSchema';

export interface INewCommentProps<T> {
  onSubmit: (x: { content: string; type: T }) => Promise<void>;
  onSubmitFetchStatus: IFetchStatus;
  onSubmitFetchError?: Error;
  commentTypeOptions: ISelectOption<T>[];
}

const MinSelectField = styled(SelectField)`
  min-width: 180px;
`;

export const NewComment = <T extends any>({
  onSubmit,
  onSubmitFetchStatus,
  onSubmitFetchError,
  commentTypeOptions,
}: INewCommentProps<T>) => {
  const initialValue: { content?: string; type?: T } = {};
  return (
    <div className={'basis-1/4'}>
      <Card title={`New Comment`}>
        <Formik
          initialValues={initialValue}
          validateOnMount
          validationSchema={commentSchema<T>()}
          onSubmit={async ({ content, type }, formikHelpers) => {
            try {
              // Validation says these are required
              await onSubmit({ content: content!, type: type! });
              formikHelpers.resetForm();
            } catch (e: any) {}
          }}
        >
          {({ isValid }) => (
            <Form>
              <Grid>
                <AreaField name={'content'} rows={4} />
                <Grid templateColumns={'1fr min-content'}>
                  <MinSelectField options={commentTypeOptions} name={'type'} placeholder={`Comment Type`} />
                  <FlexRow>
                    <FetchStatusFlow
                      defaultNode={<></>}
                      fetchStatus={onSubmitFetchStatus}
                      error={onSubmitFetchError}
                      fetchingNode={<RotatingIcon type={IconType.Loading} />}
                    >
                      <PrimaryText>
                        <FontAwesomeIcon icon={faCheck} />
                      </PrimaryText>
                    </FetchStatusFlow>
                    <Button intent={'primary'} type={'submit'} disabled={!isValid || onSubmitFetchStatus.fetching}>
                      Submit
                    </Button>
                  </FlexRow>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Card>
    </div>
  );
};

const PrimaryText = styled(Header2Text)`
  color: ${(props) => props.theme.colors.primary};
`;
